import { Alert } from 'reactstrap'

export default function LoginError(props) {
  const { loginError, mutationError } = props
  console.log('LoginError rendered', loginError, mutationError)

  return (
    <Alert color="danger" isOpen={loginError ? true : false || mutationError ? true : false} data-cy="login-alert">
      {loginError || (mutationError && mutationError.message)}
    </Alert>
  )
}
